// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Time = function Time(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M14.947 8A6.947 6.947 0 108 14.947 6.947 6.947 0 0014.947 8zM8 13.643a5.643 5.643 0 113.99-1.653A5.623 5.623 0 018 13.643z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M8.071 8.314l3.52 2.033a4.073 4.073 0 00.637-1.138L9.049 7.373V3.781a3.766 3.766 0 00-1.3 0v4.344z"
    }))
  );
};

export default Time;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Time.js
// module id = 1056
// module chunks = 0